import B_CanvasGame from '../../../base/dev/frame/B_CanvasGame';
import B_Define from '../../../base/dev/util/B_Define';
import R_World from './R_World';
import R_Define from '../util/R_Define';
import R_Animate from '../animate/R_Animate';
import R_DefaultResource from '../util/R_DefaultResource.json';
import R_Tool from './R_Tool';

import B_Sound from 'canvas/base/dev/sound/B_Sound';
import G_Define from 'canvas/grid/dev/util/G_Define';

const init = () => {
    return class R_Canvas extends B_CanvasGame {
        constructor(wrapper, id, queue, cb) {
            const resource = { ...queue };

            // 배경 세트 관련 처리
            const bgSet = {};
            for (const key in resource) {
                const { type, bg } = resource[key];
                switch (type) {
                    case R_Define.BG_SET_TYPE: {
                        bg.sort((a, b) => a.order - b.order);
                        bg.forEach((e, i) => {
                            resource[`${key}_${i}`] = e;
                        });
                        bgSet[key] = resource[key];
                        delete resource[key];
                        break;
                    }
                    default:
                }
            }

            super(
                wrapper,
                id,
                { ...R_DefaultResource, ...resource },
                cb
            );

            this._gameType = R_Define.GAME_TYPE;
            this.ANIMATE = new R_Animate(this);
            this.__speed = R_Define.DEFAULT_SPEED;

            this.SOUND = new B_Sound(this.mut, G_Define.SOUND_RES, G_Define.SOUND_SRC, this.bgm);

            this._bgSet = bgSet;
        }

        /**
         * [ Function :: loadTool ]
         *
         * @DES :: R_Tool 로드
         * @O.P :: null
         */
        loadTool() {
            this.TOOL = new R_Tool(this, this.CANVAS.width, this.CANVAS.height);
            this.STAGE.addChild(this.TOOL);
        }

        /**
         * [ Function :: setSpriteSheet ]
         *
         * @DES :: 스프라이트 시트 객체 미리 등록
         * @O.P :: null
         */
        setSpriteSheet() {
            this._sprite = {};
            Object.keys(this._res).forEach((key) => {
                const { type, result, src, load } = this._res[key];
                if (type === R_Define.HERO_TYPE) {
                    const bmps = [];
                    if (!load) {
                        // result.images = result.images.map((e, i) => this._res[`${key}-image-${i}`].result);
                        result.images = result.images.map((e, i) => {
                            const res = this._res[`${key}-image-${i}`];
                            const { result: img } = res;
                            const bmp = new createjs.Bitmap(img);
                            bmp.cache(0, 0, img.width, img.height);
                            res.bmp = bmp;
                            bmps.push(bmp);
                            return bmp.cacheCanvas;
                        });
                        this._res[key].load = true;
                    } else {
                        result.images.forEach((e, i) => bmps.push(this._res[`${key}-image-${i}`].bmp))
                    }
                    const sprite = new createjs.SpriteSheet(result);
                    sprite.bmps = bmps;
                    sprite.src = src;
                    this._sprite[key] = sprite;
                }
            });
        }

        _getWorld() {
            return new R_World(this);
        }

        // 게임 속도
        get speed() { return this.__speed; }

        set speed(speed) {
            // 속도 최소 / 최대 값 지정
            if (speed > R_Define.MAX_SPEED) speed = R_Define.MAX_SPEED;
            else if (speed < R_Define.MIN_SPEED) speed = R_Define.MIN_SPEED;

            this.__speed = speed;
            createjs.Ticker.framerate = B_Define.FPS * speed;

            if (this.WORLD) {
                const [{ column }] = Object.values(this.WORLD.LIST[B_Define.GRID_TYPE]);

                Object.values(this.WORLD.LIST[B_Define.REAL_TYPE]).forEach((e) => {
                    switch (e.type) {
                        case R_Define.GOAL_TYPE:
                        case R_Define.HIT_ITEM_TYPE:
                        case R_Define.OBSTACLE_TYPE: {
                            // 회전 애니메이션 관련 처리 (속도가 0이면 멈추고, 0이 아니면 다시 시작)
                            if (e.x <= column && e._rotate && !e._isRotate) e.rotate();
                            break;
                        }
                        case R_Define.HERO_TYPE: {
                            // 캐릭터에 속도 전달
                            e._speed = speed;
                            break;
                        }
                        default:
                    }
                });
            }
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_Canvas.js